export default __webpack_public_path__ + "static/logo-karolinska-universitetssjukhuset-186059fdb1821a9617a24e68d1e515f1.svg";